import { FC } from 'react';
import { AlertCircle } from 'lucide-react';

interface ClientsErrorStateProps {
  errorMessage: string;
  onRetry: () => void;
}

export const ClientsErrorState: FC<ClientsErrorStateProps> = ({ errorMessage, onRetry }) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-slate-100">Clients</h2>
          <p className="text-gray-600 dark:text-slate-400 mt-1">
            Manage your client relationships
          </p>
        </div>
      </div>
      <div className="bg-red-50 dark:bg-red-900/20 rounded-lg p-8 text-center border border-red-200 dark:border-red-800">
        <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-red-800 dark:text-red-200 mb-2">
          Failed to Load Clients
        </h3>
        <p className="text-red-600 dark:text-red-300 mb-4">{errorMessage}</p>
        <button
          onClick={onRetry}
          className="px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};
